import * as styled from '../styles/persona-choice-card';
import { HeroArrowIcon } from './hero-arrow-icon';

type Props = {
  accent: LandingV2.PersonaAccent;
  kicker: string;
  title: string;
  description: string;
  categories: LandingV2.PersonaCategory[];
  onSelect: () => void;
};

export const PersonaChoiceCard = ({
  accent,
  kicker,
  title,
  description,
  categories,
  onSelect,
}: Props) => (
  <styled.Card $accent={accent} onClick={onSelect}>
    <styled.TopRow>
      <styled.Heading>
        <styled.Kicker $accent={accent}>{kicker}</styled.Kicker>
        <styled.Title>{title}</styled.Title>
      </styled.Heading>
      <styled.Arrow $accent={accent} aria-hidden="true">
        <HeroArrowIcon />
      </styled.Arrow>
    </styled.TopRow>
    <styled.Description>{description}</styled.Description>
    <styled.Divider $accent={accent} />
    <styled.ChipRow>
      {categories.map((category) => (
        <styled.Chip key={category.label} $accent={accent}>
          {category.label}
        </styled.Chip>
      ))}
    </styled.ChipRow>
  </styled.Card>
);
